/* ======================================
   GLOBAL FILTER STATE
====================================== */

let activeCategory = "all";
let searchKeyword = "";
let currentSort = "recent";

// search option
document.addEventListener('DOMContentLoaded', () => {

  const search = document.getElementById('reorder-search');

  if (!search) return;

  const products = document.querySelectorAll('.reorder-row');

  search.addEventListener('input', function () {

    const keyword = this.value.trim().toLowerCase();

    products.forEach(product => {

      const title = product.dataset.title || '';
      const sku = product.dataset.sku || '';
      const vendor = product.dataset.vendor || '';

      const match =
        title.includes(keyword) ||
        sku.includes(keyword) ||
        vendor.includes(keyword);

      product.style.display = match ? '' : 'none';

    });

  });

});

//sorting filter area
const sortSelect = document.getElementById('reorder-sort');

if (sortSelect) {

    sortSelect.addEventListener('change', function () {

        const container = document.getElementById('reorder-product-list');

        const items = Array.from(container.querySelectorAll('.reorder-row'));

        switch (this.value) {

            case 'name-asc':

                items.sort((a, b) =>
                    a.dataset.title.localeCompare(b.dataset.title)
                );

                break;

            case 'name-desc':

                items.sort((a, b) =>
                    b.dataset.title.localeCompare(a.dataset.title)
                );

                break;

            case 'price-asc':

                items.sort((a, b) =>
                    Number(a.dataset.price) - Number(b.dataset.price)
                );

                break;

            case 'price-desc':

                items.sort((a, b) =>
                    Number(b.dataset.price) - Number(a.dataset.price)
                );

                break;

            case 'stock':

                items.sort((a, b) =>
                    Number(b.dataset.stock) - Number(a.dataset.stock)
                );

                break;

            default:

                items.sort((a, b) =>
                    Number(b.dataset.date) - Number(a.dataset.date)
                );

        }

        items.forEach(item => container.appendChild(item));

    });

}
/* ======================================
   BUILD CATEGORY FILTER
   Supports English, Japanese & Nepali
====================================== */

function buildCategoryFilter() {

    const container = document.getElementById(
        "reorder-category-filter"
    );

    if (!container) return;

    /* GET CURRENT LANGUAGE */

    const language = (
        document.documentElement.lang || "en"
    ).toLowerCase().split("-")[0];

    /* ALL BUTTON TRANSLATIONS */

    const allLabels = {
        en: "All",
        ja: "すべて",
        ne: "सबै"
    };

    /* GET PRODUCT ROWS */

    const rows = [
        ...document.querySelectorAll(".reorder-row")
    ];

    const categories = new Set();

    rows.forEach(row => {

        const category = row.dataset.category || "other";

        categories.add(category);

    });

    let html = "";

    /* ======================================
       ALL CATEGORY BUTTON
    ====================================== */

    html += `
        <button
            type="button"
            class="active"
            data-category="all"
        >
            ${allLabels[language] || allLabels.en}
        </button>
    `;

    /* ======================================
       CATEGORY BUTTONS
    ====================================== */

    [...categories]
        .sort()
        .forEach(category => {

            const label = formatCategory(category);

            html += `
                <button
                    type="button"
                    data-category="${category}"
                >
                    ${label}
                </button>
            `;

        });

    /* RENDER BUTTONS */

    container.innerHTML = html;

    /* ======================================
       CATEGORY CLICK EVENT
    ====================================== */

    container
        .querySelectorAll("button")
        .forEach(button => {

            button.addEventListener("click", function() {

                /* UPDATE ACTIVE BUTTON */

                container
                    .querySelectorAll("button")
                    .forEach(btn => {
                        btn.classList.remove("active");
                    });

                this.classList.add("active");

                /* UPDATE FILTER STATE */

                activeCategory = this.dataset.category;

                /* APPLY CATEGORY + SEARCH FILTERS */

                applyFilters();

            });

        });

}

/* ======================================
   CATEGORY TRANSLATIONS
====================================== */

const categoryTranslations = {
    "atta": {
        ja: "アタ（全粒粉）",
        ne: "आटा"
    },
    "other-flour": {
        ja: "その他の粉類",
        ne: "अन्य पिठो"
    },
    "rava": {
        ja: "ラバ（セモリナ）",
        ne: "रवा"
    },
    "canned-sweet": {
        ja: "缶入りスイーツ",
        ne: "क्यानमा राखिएका मिठाई"
    },
    "chikki": {
        ja: "チッキ",
        ne: "चिक्की"
    },
    "namkeen-savories": {
        ja: "ナムキーン・スナック",
        ne: "नमकिन तथा नमकिन स्न्याक्स"
    },
    "nuts-and-dry-snacks": {
        ja: "ナッツ・ドライスナック",
        ne: "नट्स तथा ड्राइ स्न्याक्स"
    },
    "packed-sweet": {
        ja: "パック入りスイーツ",
        ne: "प्याक गरिएका मिठाई"
    },
    "snacks": {
        ja: "スナック",
        ne: "स्न्याक्स"
    },
    "dal": {
        ja: "豆類（ダル）",
        ne: "दाल"
    },
    "fresh-fruit": {
        ja: "新鮮な果物",
        ne: "ताजा फलफूल"
    },
    "fresh-vegetable": {
        ja: "新鮮な野菜",
        ne: "ताजा तरकारी"
    },
    "milk-product": {
        ja: "乳製品",
        ne: "दुग्धजन्य पदार्थ"
    },
    "roti-and-naan": {
        ja: "ロティ・ナン",
        ne: "रोटी तथा नान"
    },
    "snack-frozen-product": {
        ja: "冷凍スナック",
        ne: "फ्रोजन स्न्याक्स"
    },
    "vegetable": {
        ja: "野菜",
        ne: "तरकारी"
    },
    "ghee": {
        ja: "ギー",
        ne: "घिउ"
    },
    "oil": {
        ja: "食用油",
        ne: "खाने तेल"
    },
    "hair-care": {
        ja: "ヘアケア",
        ne: "कपालको हेरचाह"
    },
    "oral-care": {
        ja: "オーラルケア",
        ne: "मुखको हेरचाह"
    },
    "personal-care": {
        ja: "パーソナルケア",
        ne: "व्यक्तिगत हेरचाह"
    },
    "festival-and-pooja-product": {
        ja: "祭事・プージャ用品",
        ne: "चाडपर्व तथा पूजाका सामग्री"
    },
    "recipe-book": {
        ja: "レシピ本",
        ne: "रेसिपी पुस्तक"
    },
    "dry-fruit": {
        ja: "ドライフルーツ",
        ne: "सुक्खा फलफूल"
    },
    "nut": {
        ja: "ナッツ",
        ne: "नट्स"
    },
    "baking-soda": {
        ja: "重曹",
        ne: "बेकिङ सोडा"
    },
    "coconut-product": {
        ja: "ココナッツ製品",
        ne: "नरिवलका उत्पादन"
    },
    "food-color": {
        ja: "食用色素",
        ne: "खाद्य रङ"
    },
    "jaggery-sugar-and-salt": {
        ja: "ジャガリー・砂糖・塩",
        ne: "सख्खर, चिनी तथा नुन"
    },
    "mouth-freshner": {
        ja: "口直し・口臭ケア",
        ne: "मुख ताजा बनाउने सामग्री"
    },
    "onion-garlic-and-ginger": {
        ja: "玉ねぎ・にんにく・生姜",
        ne: "प्याज, लसुन तथा अदुवा"
    },
    "others-other-grocery": {
        ja: "その他の食料品",
        ne: "अन्य किराना सामान"
    },
    "papad": {
        ja: "パパド",
        ne: "पापड"
    },
    "soya-product": {
        ja: "大豆製品",
        ne: "भटमासका उत्पादन"
    },
    "tamarind": {
        ja: "タマリンド",
        ne: "इमली"
    },
    "chutney-and-sauce": {
        ja: "チャツネ・ソース",
        ne: "चटनी तथा सस"
    },
    "paste-pickle-paste-chutney": {
        ja: "ペースト・ピクルス",
        ne: "पेस्ट तथा अचार"
    },
    "pickle": {
        ja: "ピクルス・アチャール",
        ne: "अचार"
    },
    "canned-product": {
        ja: "缶詰製品",
        ne: "क्यानमा राखिएका खाद्य सामग्री"
    },
    "curry-and-rice": {
        ja: "カレー・ライス",
        ne: "करी तथा भात"
    },
    "instant-mix": {
        ja: "インスタントミックス",
        ne: "इन्स्ट्यान्ट मिक्स"
    },
    "noodle-and-vermicelli": {
        ja: "麺・バーミセリ",
        ne: "चाउचाउ तथा सेवई"
    },
    "snack-ready-to-eat-and-cook": {
        ja: "すぐ食べられる食品・調理用スナック",
        ne: "तयार खाने तथा पकाउने स्न्याक्स"
    },
    "rice": {
        ja: "米",
        ne: "चामल"
    },
    "grounded-spice": {
        ja: "粉末スパイス",
        ne: "पिसेको मसला"
    },
    "herb": {
        ja: "ハーブ",
        ne: "जडीबुटी"
    },
    "mix-spice": {
        ja: "ミックススパイス",
        ne: "मिश्रित मसला"
    },
    "whole-spice": {
        ja: "ホールスパイス",
        ne: "सिङ्गो मसला"
    },
    "coffee": {
        ja: "コーヒー",
        ne: "कफी"
    },
    "pulp-and-juice": {
        ja: "果肉・ジュース",
        ne: "फलफूलको गुदी तथा जुस"
    },
    "tea": {
        ja: "お茶",
        ne: "चिया"
    },
    "beer": {
        ja: "ビール",
        ne: "बियर"
    },
    "rum": {
        ja: "ラム酒",
        ne: "रम"
    },
    "whisky": {
        ja: "ウイスキー",
        ne: "ह्विस्की"
    },
    "wine": {
        ja: "ワイン",
        ne: "वाइन"
    }
};


/* ======================================
   FORMAT CATEGORY NAME BY LANGUAGE
====================================== */

function formatCategory(value) {

    const language = (
        document.documentElement.lang || "en"
    ).toLowerCase().split("-")[0];

    const translations = categoryTranslations[value];

    if (translations && translations[language]) {
        return translations[language];
    }

    /* English fallback */
    return value
        .replace(/-/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());
}
/* ======================================
   APPLY FILTERS
====================================== */

function applyFilters(){

    const rows = document.querySelectorAll(".reorder-row");

    rows.forEach(row=>{

        const title = row.dataset.title || "";

        const category = row.dataset.category || "";

        const matchCategory =
            activeCategory === "all" ||
            category === activeCategory;

        const matchSearch =
            title.includes(searchKeyword);

        if(matchCategory && matchSearch){

            row.style.display="grid";

        }else{

            row.style.display="none";

        }

    });

}
buildCategoryFilter();

applyFilters();

document.querySelectorAll(".reorder-category-card").forEach(card => {

    card.addEventListener("click", function(){

        document
            .querySelectorAll(".reorder-category-card")
            .forEach(c => c.classList.remove("active"));

        this.classList.add("active");

        const category = this.dataset.category;

        document
            .querySelectorAll(".reorder-row")
            .forEach(row => {

                if(category === "all"){

                    row.style.display = "grid";

                    return;

                }

                row.style.display =
                    row.dataset.category === category
                    ? "grid"
                    : "none";

            });

    });

});

/* ======================================
   REORDER TABS
====================================== */

document.querySelectorAll(".reorder-tab").forEach(tab=>{

    tab.addEventListener("click",function(){

        document.querySelectorAll(".reorder-tab")
        .forEach(btn=>btn.classList.remove("active"));

        document.querySelectorAll(".reorder-tab-content")
        .forEach(content=>content.classList.remove("active"));

        this.classList.add("active");

        if(this.dataset.tab==="past-orders"){

            document
            .getElementById("past-orders-content")
            .classList.add("active");

        }else{

            document
            .getElementById("last-order-content")
            .classList.add("active");

        }

    });

});
/* ======================================
   LAST ORDER - ADD ALL TO CART
====================================== */

(function () {

    const addAllButton = document.querySelector('[data-last-order-add-all]');

    if (!addAllButton) return;

    if (addAllButton.dataset.initialized === 'true') return;

    addAllButton.dataset.initialized = 'true';

    const buttonText = addAllButton.querySelector(
        '[data-last-order-add-all-text]'
    );

    const loader = addAllButton.querySelector(
        '.last-order-add-all__loader'
    );

    const prefix = window.KT_PREFIX || '';

    function setLoading(isLoading) {

        addAllButton.disabled = isLoading;

        addAllButton.classList.toggle(
            `${prefix}working`,
            isLoading
        );

        if (buttonText) {
            buttonText.textContent = isLoading
                ? 'Adding...'
                : 'Add All Products to Cart';
        }

        if (loader) {
            loader.style.display = isLoading
                ? 'inline-flex'
                : 'none';
        }

    }

    async function addAllProducts() {

        const rows = Array.from(
            document.querySelectorAll(
                '#last-order-content .last-order-products .reorder-row'
            )
        );

        if (!rows.length) {
            return;
        }

        /*
         * Build one Shopify cart request.
         *
         * Only available products are included.
         */
        const items = rows
    .map(row => {

        const variantId = parseInt(
            row.dataset.variantId,
            10
        );

        const quantity = parseInt(
            row.dataset.quantity,
            10
        );

        const stock = row.dataset.stock;

        if (
            !variantId ||
            !quantity ||
            stock !== '1'
        ) {
            return null;
        }

        /*
         * Get the expiry date from the
         * parent Last Order product.
         */
        const parentItem =
            row.closest('[data-last-order-item]');

        const expirationDate =
            parentItem?.dataset.expirationDate || '';

        /*
         * Build the normal cart item.
         */
        const item = {
            id: variantId,
            quantity: quantity
        };

        /*
         * Add Expiration Date only when
         * the product has an expiry metafield.
         */
        if (expirationDate) {
            item.properties = {
                'Expiration Date': expirationDate
            };
        }

        return item;

    })
    .filter(Boolean);

        if (!items.length) {
            return;
        }

        setLoading(true);

        try {

            /*
             * Use Shopify's native Ajax Cart endpoint.
             * This is the same endpoint used by Local's ProductForm.
             */
            const response = await fetch(
                `${KROWN.settings.routes.cart_add_url}.js`,
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },

                    body: JSON.stringify({
                        items: items
                    })
                }
            );

            const result = await response.json();

            /*
             * Shopify returns status 422 when
             * one or more items cannot be added.
             */
            if (!response.ok || result.status === 422) {

                let message = 'Unable to add products to cart.';

                if (typeof result.description === 'string') {
                    message = result.description;
                } else if (typeof result.message === 'string') {
                    message = result.message;
                }

                throw new Error(message);
            }

            /*
             * IMPORTANT:
             *
             * This is the same helper-cart section
             * used by Local's ProductForm.
             */
            const cartResponse = await fetch(
                '?section_id=helper-cart'
            );

            const cartText = await cartResponse.text();

            const sectionHTML =
                new DOMParser()
                    .parseFromString(
                        cartText,
                        'text/html'
                    );

            /*
             * Update existing Local cart drawer.
             */
            const newCartForm =
                sectionHTML.getElementById(
                    'AjaxCartForm'
                );

            const newCartSubtotal =
                sectionHTML.getElementById(
                    'AjaxCartSubtotal'
                );

            const currentCartForm =
                document.getElementById(
                    'AjaxCartForm'
                );

            const currentCartSubtotal =
                document.getElementById(
                    'AjaxCartSubtotal'
                );

            if (
                newCartForm &&
                currentCartForm
            ) {

                currentCartForm.innerHTML =
                    newCartForm.innerHTML;

                /*
                 * Re-initialize Local cart item
                 * functionality.
                 */
                if (
                    typeof currentCartForm.ajaxifyCartItems ===
                    'function'
                ) {
                    currentCartForm.ajaxifyCartItems();
                }

            }

            if (
                newCartSubtotal &&
                currentCartSubtotal
            ) {

                currentCartSubtotal.innerHTML =
                    newCartSubtotal.innerHTML;

            }

            /*
             * Update Local theme header cart count.
             */
            const newCartCount =
                sectionHTML.querySelector(
                    '[data-cart-count]'
                );

            const newCartTotal =
                sectionHTML.querySelector(
                    '[data-cart-total]'
                );

            if (newCartCount) {

                document
                    .querySelectorAll(
                        '[data-header-cart-count]'
                    )
                    .forEach(elm => {

                        elm.textContent =
                            newCartCount.textContent;

                    });

            }

            if (newCartTotal) {

                document
                    .querySelectorAll(
                        '[data-header-cart-total]'
                    )
                    .forEach(elm => {

                        elm.textContent =
                            newCartTotal.textContent;

                    });

            }

            /*
             * Announce cart update using the
             * same Local theme event.
             */
            if (
                window.KROWN &&
                KROWN.functions &&
                typeof KROWN.functions.eventDispatcher ===
                'function'
            ) {

                KROWN.functions.eventDispatcher(
                    'krown:cart:add',
                    {
                        productForm: null,
                        variantId: items
                            .map(item => item.id)
                            .join(',')
                    }
                );

            }

            /*
             * Open the EXISTING Local cart sidebar.
             */
            const cartSidebar =
                document.getElementById(
                    'site-cart-sidebar'
                );

            if (
                cartSidebar &&
                typeof cartSidebar.show === 'function'
            ) {

                cartSidebar.show();

            }

        } catch (error) {

            console.error(
                'Last Order - Add All error:',
                error
            );

            /*
             * Optional alert using the Local
             * theme's existing alert class.
             */
            const alert = document.createElement('div');

            alert.className =
                `${prefix}alert ${prefix}alert--error`;

            alert.textContent =
                error.message ||
                'Unable to add products to cart.';

            const summary =
                document.querySelector(
                    '.last-order-summary'
                );

            if (summary) {

                const oldAlert =
                    summary.querySelector(
                        '[data-last-order-error]'
                    );

                if (oldAlert) {
                    oldAlert.remove();
                }

                alert.dataset.lastOrderError = 'true';

                summary.appendChild(alert);

            }

        } finally {

            setLoading(false);

        }

    }

    addAllButton.addEventListener(
        'click',
        addAllProducts
    );

})();